/* eslint no-underscore-dangle:0 */
import { GetGithubIssueData, GithubSearch } from '../api/githubSearch';
import { GoogleDriveSearch } from '../api/googleDriveSearch';
import { EVENTS } from './CONSTANTS';
import { getApiGoogleDriveIntegrationUrl } from './urlHelper';

const setGithubIntegration = (teamId) => {
    // Check if we have an active request, or integration already set
    if (window._tettraGithubSearchStore || window.githubSearch) return;
    // Set _tettraGithubSearchStore as a latch variable
    window._tettraGithubSearchStore = {};

    $.get(`/api/teams/${teamId}/integrations/github`)
        .done(({ token, repositoriesNames }) => {
            if (token) {
                window.getGithubIssueData = new GetGithubIssueData(token);
                window.githubSearch = new GithubSearch(token, repositoriesNames);
                window.dispatchEvent(new Event(EVENTS.GITHUB_TOKEN_LOADED));
            }
        }).fail((error) => {
            console.error(error);
            window._tettraGithubSearchStore = null;
            window.githubSearch = null;
        });
};

export const setGoogleDriveIntegration = (teamId, userId) => {
    // Check if we have an active request, or integration already set
    if (window._tettraGoogleDriveSearchStore || window.googleDriveSearch) return;
    // Set _tettraGoogleDriveSearchStore as a latch variable
    window._tettraGoogleDriveSearchStore = {};

    $.get(getApiGoogleDriveIntegrationUrl(userId))
        .done(({ token }) => {
            if (token) {
                window.googleDriveSearch = new GoogleDriveSearch(token);
            } else {
                window.googleDriveSearch = false;
            }
            window.dispatchEvent(new Event(EVENTS.GOOGLE_TOKEN_LOADED));
        }).fail((error) => {
            console.error(error);
            window._tettraGoogleDriveSearchStore = null;
            window.googleDriveSearch = null;
        });
};

const setIntegrationForUser = (teamId, userId, config) => {
    const { readOnly, enableExternalSuggestions } = config;

    if (!window.loggedIn || !enableExternalSuggestions || !userId || !teamId) return;

    if (!readOnly) {
        setGoogleDriveIntegration(teamId, userId);
    }

    setGithubIntegration(teamId);
};

export default setIntegrationForUser;
